import React from 'react'
import { Form as FinalForm } from 'react-final-form'
import PropTypes from 'prop-types'

import { RailsForm } from '@support/RailsForm'
import InputForm from '../Form'
import NewOtherForm from './Form'
import { validate, otherInputShape } from '@models/inputs/other'

const NewOther = ({ model, categories, o }) => {
  const initialValues = {
    category: categories[0].id
  }

  const title = `${I18n.t('actions.add')} ${I18n.t(`v4/input.kinds.${model.kind}`)}`

  return (
    <RailsForm
      component={FinalForm}
      action='create'
      initialValues={initialValues}
      url={`/v4/o/${o}/inputs/other`}
      validade={validate}
      render={(props) => (
        <InputForm
          title={title}
        >
          <NewOtherForm
            {...props}
            categories={categories}
            action={title}
            o={o}
          />
        </InputForm>
      )}
    />
  )
}

NewOther.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  })),
  model: otherInputShape
}

export default NewOther
